import { acf_map } from '../modules/map';
import { get_time } from '../modules/clock';

export default {
	init() {
		// JavaScript to be fired on all pages
		acf_map();
		get_time();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/templateContact.js